import { configureStore } from '@reduxjs/toolkit'
import {authSlice,LabListSlice,machinelistSlice,machineInstallRequestListSlice,
    smsPurchaseSlice,cableRequestSlice,APISlice,LabBackupInfoSlice, LabProcessSlice, GeneralLabInfoSlice, LabFeedbackSlice,ClientComputerInfoSlice,MiscellaneousFunctionsSlice, FinancialBalanceSlice, temperatureInstallRequestListSlice, temperatureListSlice, PadvishRequestSlice, PadvishRequestLicenseSlice, LabPathologyProcessSlice, GeneralInfoSlice, parsicUsersSlice} from '../reducers';
import requestPaymentSlice from '../reducers/requestPaymentSlice';
import labUsersSlice from '../reducers/labUsersSlice';

const store =  configureStore({
    reducer: {
        auth: authSlice,
        labList: LabListSlice,
        machineList:machinelistSlice,
        temperatureList:temperatureListSlice,
        machineInstallRequestList:machineInstallRequestListSlice,
        temperatureInstallRequestList:temperatureInstallRequestListSlice,
        smsPurchaseList:smsPurchaseSlice.reducer,
        cableRequestList:cableRequestSlice.reducer,
        api:APISlice.reducer,
        requestPaymen:requestPaymentSlice,
        backupInfo: LabBackupInfoSlice,
        processList:LabProcessSlice,
        generalLabInfo:GeneralLabInfoSlice,
        labFeedbacks:LabFeedbackSlice,
        computerList:ClientComputerInfoSlice,
        miscellaneousList:MiscellaneousFunctionsSlice,
        taxList:FinancialBalanceSlice,
        padvishRequestList:PadvishRequestSlice,
        padvishRequestLicenseList:PadvishRequestLicenseSlice,
        labUsers:labUsersSlice,
        pathologyProcessList:LabPathologyProcessSlice,
        generalInfo:GeneralInfoSlice,
        parsicUsers:parsicUsersSlice
    },

})


export type RootState = ReturnType<typeof store.getState>

export type AppDispatch = typeof store.dispatch

export default store;